import React from "react";
import { DocumentRenderer } from "components";
import SingleLineTable from "./SingleLine";
import MultiLinesTable from "./MultiLines";
export default ({
    items,
    t,
    client,
    settings: settingsProp,
    selectedOrganisation,
    ...props
}) => {

    return (
        <>
            {
                items?.length > 0 && (
                items.length > 1 ?
                        <DocumentRenderer {...props}>
                            <div className="container-fluid m-0 p-0">
                                <MultiLinesTable items={items} selectedOrganisation={selectedOrganisation}/>
                            </div>
                        </DocumentRenderer>
                        :
                        <DocumentRenderer {...props}>
                            <div className="container-fluid m-0 p-0">
                                <SingleLineTable item={items[0]} selectedOrganisation={selectedOrganisation}/>
                            </div>
                        </DocumentRenderer>
                )
            }
        </>

    );
};
